export default "__VITE_ASSET__DQ$ZMjvo__"